{
  "title": "Bill of Materials",
  "subtitle": "Define what Raw Material / Semi-Finished Good components go into producing a Finished Good or Semi-Finished Good — used by Material Request's BOM explosion.",
  "addBom": "Add BOM",
  "view": "View",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "number": "BOM Number",
    "material": "Material",
    "type": "Type",
    "qty": "Qty",
    "baseQty": "Base Qty",
    "lines": "Components",
    "status": "Status",
    "actions": "Actions"
  },
  "form": {
    "headerMaterial": "Header Material (FG/SFG)",
    "headerMaterialHint": "The Finished Good or Semi-Finished Good this BOM produces — fixed once created.",
    "baseQty": "Base Qty",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "remarks": "Remarks",
    "components": "Components",
    "componentMaterial": "Component Material (RM/SFG)",
    "qty": "Qty",
    "addLine": "Add Component"
  },
  "discardChanges": "Discard Changes",
  "saveBom": "Save BOM",
  "deleteBom": {
    "message": "This BOM will be permanently removed."
  }
}
